export const NOT_EDITABLE_ROWS = {
  STUECKLISTE: [],
  STANDARD: [],
};
